<template>
  <form @submit.prevent="handleSubmit" class="message-form">
    <input
      class="message-input"
      name="newMessage"
      placeholder="Compose your message and hit ENTER to send"
      :value="newMessage"
      @input="handleInput"
    />
  </form>
</template>

<script>
import { sendMessage, launchChat, createRoom, addSupportStaffToRoom, connectToRoom } from '../chat/chat.js';

export default {
  name: 'ChatFooter',
  props: {
    newMessage: String,
    messages: Array,
    currentUser: {
      type: Object,
      required: true,
      default: null,
    },
  },
  methods: {
    handleInput(event) {
      const { name, value } = event.target;
      this.$emit('update-input', name, value);
    },
    handleSubmit() {
      this.$emit('send-message');
    },
    sendMessage,
    launchChat,
    createRoom,
    addSupportStaffToRoom,
    connectToRoom,
  }
}
</script>